// extracted by mini-css-extract-plugin
module.exports = {"bird1":"LighthouseAndBirds_bird1__3RS5y","float":"LighthouseAndBirds_float__3Ler4","bird2":"LighthouseAndBirds_bird2__3r4-_","bird3":"LighthouseAndBirds_bird3__fH7b9"};